import React, { useEffect } from "react";
import * as ModalR from 'react-modal';
import * as Yup from 'yup';
import { Field, Form, Formik, ErrorMessage } from 'formik';
import { Button } from "components/Button";
import axios from "axios";
// import moment from "moment";
import { Img } from "components";
import OTPModal from "pages/SoomuchDemo/Communication/OTPModal";
import SuccessModal from "pages/SoomuchDemo/Communication/SuccessModal";
import { API_HOST } from "utils";

const BRANCH_COUNT_LIST = [...Array.from({ length: 10 }, (_, i) => i + 1), "More than 10"];
const TYPE_OF_ORG_LIST = ['School', 'College', 'Coaching', 'Engineering', 'Graduation', 'Post Graduation'];
const LANGUAGE_LIST = ["English", "Telugu", "Hindi - COMING SOON"];
const ROLE_LIST = ['Principal', 'Faculty', 'Owner', 'Others'];

// const SOURCE_NAME = {
//     "/": "COMM",
//     "/customer-satisfaction": "FEEDBACK",
//     "/fee-collection-process": "FEE",
// }

const SOURCE_NAME = [
    "COMM",
    "FEEDBACK",
    "FEE"
]



// const getCurrentDateAndTime = (given, into12format = false, toSend?) => {
//     if (moment(given).isValid()) {
//         if (toSend)
//             return moment(given).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
//         if (!into12format) {
//             return moment.utc(given).local().format('YYYY-MM-DD HH:mm:ssZ');
//         }
//         return moment.utc(given).local().format('DD/MM/YYYY hh:mm A');
//     }
//     return moment.utc(new Date()).local().format('DD/MM/YYYY hh:mm A');
// };

const customStylesAskModal = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '30rem',
        maxWidth: '80%',
        minHeight: '10rem',
        borderRadius: '1.5em',
        boxShadow: '0px 16px 32px 4px rgba(0, 0, 0, 0.15)',
        padding: '1.3em',
    },
    overlay: {
        background: 'rgba(0, 0, 0, 0.4)',
        zIndex: 999
    },
};

interface Props {
    showModal: any; customStyles: any; setshowModal: any; handleVideoSaving: any; isHW?: any, externalSource?: any;
}

const CommunicationModal = ({
    showModal, customStyles, setshowModal, handleVideoSaving/* , handleSuccessModal */, isHW, externalSource
}: Props) => {

    const [confirmationModal, setConfirmationModal] = React.useState({ display: false, data: {} });
    const [formLoader, setFormLoader] = React.useState(false);
    const [demoCampaignID, setDemoCampaignID] = React.useState<any>({});
    const [openModal, setOpenModal] = React.useState<any>(false);
    const [successModal, setSuccessModal] = React.useState<any>(false);

    const form_data = JSON.parse(sessionStorage.getItem('form_data')) || {};

    // useEffect(() => {
    //     if (!!demoCampaignID?.DEMO_CAMPAIGN_ID) {
    //         setOpenModal(openModal => ({
    //             ...demoCampaignID
    //         }));
    //     }
    // }, [demoCampaignID?.DEMO_CAMPAIGN_ID])

    useEffect(() => {
        if (!!showModal?.DATA?.SOURCE) {
            setDemoCampaignID(demoCampaignID => showModal?.DATA)
        }
    }, [showModal?.DATA?.SOURCE])

    const initialValues = {
        NAME: '',
        LANGUAGE: '',
        INSTITUTE_NAME: '',
        INSTITUTE_TYPE: '',
        MOBILE_NUMBER: '',
        TOTAL_STRENGTH: '',
        OTP: '',
        ROLE: '',
        REMARKS: '',
        SOURCE: isHW || externalSource || 'COMM',
    };

    const handelModalClose = () => {
        setshowModal({ display: false, data: {} });
    }

    const validationSchema = (IS_OTP_VALIDATION_REQUIRED) => Yup.object({
        NAME: Yup.string().required('Required'),
        LANGUAGE: Yup.string().required('Required'),
        INSTITUTE_NAME: Yup.string().required('Required'),
        MOBILE_NUMBER: Yup.number().required('Required').label("Mobile Number"),
        // SALES_USER_NUMBER: Yup.number().required('Required').label("Mobile Number"),
        TOTAL_STRENGTH: Yup.number().required('Required').label("Branch Count"),
        ...(IS_OTP_VALIDATION_REQUIRED && {
            // OTP: Yup.number().required('Required').label("OTP"),
            // SALES_USER_OTP: Yup.number().required('Required').label("Sales User OTP")
        })
    });

    const handleInsert = async (data) => {

        try {
            const insertResponse = await axios.post(`${API_HOST}/master/demoCampaign/insert`, data);
            if (insertResponse?.data?.data?.DEMO_CAMPAIGN_ID) {
                setDemoCampaignID(demoCampaignID => ({
                    ...demoCampaignID,
                    DEMO_CAMPAIGN_ID: insertResponse?.data?.data?.DEMO_CAMPAIGN_ID,
                }))
                if ([200, 201]?.includes(insertResponse?.data?.code)) {
                    setOpenModal(openModal => ({
                        ...demoCampaignID,
                        DEMO_CAMPAIGN_ID: insertResponse?.data?.data?.DEMO_CAMPAIGN_ID,
                    }));
                    handleVideoSaving("https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/enter-otp.mp4");
                    setSuccessModal(successModal => ({ key: "success", message: insertResponse?.data?.message }));
                } else {
                    throw new Error(insertResponse?.data?.message);
                }
            } else {
                setSuccessModal(successModal => ({ key: "error", message: insertResponse?.data?.message }));
            }
        } catch (err) {
            setSuccessModal(successModal => ({ key: "error", message: err?.message }));
        } finally {
            setFormLoader(false);
        }
    }

    const handleSubmit = async (values) => {
        try {
            setFormLoader(true);
            // Handle form submission
            if (demoCampaignID?.DEMO_CAMPAIGN_ID) {
                const payloadValue: any = {
                    ...demoCampaignID,
                    SOURCE: isHW || values?.SOURCE,
                    OTP: values?.OTP || demoCampaignID?.OTP,
                    SALES_USER_OTP: values?.SALES_USER_OTP,
                };

                // console.log("stroage start");

                // sessionStorage.setItem('demo_data', JSON.stringify(payloadValue));



                // sessionStorage.setItem('form_data', JSON.stringify(values));


                // console.log("stroage end");



                const campaginDetailResponse = await axios.post(`${API_HOST}/master/demoCampaignDetail/insert`, payloadValue);
                // handleSuccessModal({ display: false, ID: 0 });

                sessionStorage.setItem('demo_data', JSON.stringify({
                    ...payloadValue,
                    SOURCE: isHW ? "COMM" : payloadValue?.SOURCE,
                    IDS: isHW ? [] : campaginDetailResponse?.data?.data?.ids,
                    ALREADY_PLAYED: []
                }));
                sessionStorage.setItem('form_data', JSON.stringify({...values, SOURCE: isHW ? "COMM" : values?.SOURCE}));
                setSuccessModal(successModal => ({ key: "success", message: campaginDetailResponse?.data?.message, word: "closeALL" }));
            } else {
                const isDataIsAlreadyThere = await axios.get(`${API_HOST}/master/demoCampaign/check?mobile_number=${values?.MOBILE_NUMBER}&source=${values?.SOURCE}`);
                if (isDataIsAlreadyThere?.data?.data?.exists) {

                    setConfirmationModal({ display: true, data: values })
                } else {
                    handleInsert(values);
                }
            }
        } catch (err) {
            console.log(err);
            setSuccessModal(successModal => ({ key: "error", message: err?.message }))
        } finally {
            setFormLoader(false);
        }

    };

    return (
        <ModalR
            isOpen={showModal?.display}
            contentLabel="Example Modal"
            style={customStyles}
        >
            {confirmationModal.display && <ModalR
                isOpen={confirmationModal.display}
                contentLabel="Example Modal"
                style={customStylesAskModal}
            >
                <div className="flex justify-between">
                    <h1 className="font-bold text-xl">Confirmation</h1>
                    <button onClick={() => setConfirmationModal({ display: false, data: {} })}>
                        <Img src="/images/Close.svg" alt="close" className="h-8" />
                    </button>
                </div>
                <p className="text-medium text-md text-neutral-70 my-[1.5em]">
                    The demo for this number has already been completed. Are you sure you want to proceed with another demonstration?
                </p>
                <div className="flex justify-end">
                    <div className="flex gap-2">
                        <Button
                            size="sm"
                            type="button"
                            className="font-manropeSB rounded-lg"
                            onClick={() => {
                                setConfirmationModal({ display: false, data: {} });
                                setshowModal({ display: false, data: {} });
                            }}
                        >
                            No
                        </Button>
                        <button
                            onClick={() => {
                                handleInsert(confirmationModal?.data);
                                setConfirmationModal({ display: false, data: {} });
                            }}
                            title="Send OTP"
                            type="button"
                            className={`bg-smd_blue-normal text-[white] py-2 px-4 rounded-2xl`}>
                            Yes
                        </button>
                    </div>
                </div>
            </ModalR>}
            <div className="flex justify-between items-center py-2 px-8">
                <h1 className="font-bold text-[2.2vh]">Auto Connect Demo</h1>
            </div>
            {!!showModal?.display && <div className="px-8 py-2 overflow-y-auto max-h-[500px]">
                <Formik
                    initialValues={!!form_data?.MOBILE_NUMBER ? { ...form_data, SOURCE: showModal?.DATA?.SOURCE, OTP: "" } : initialValues}
                    validationSchema={validationSchema(demoCampaignID?.DEMO_CAMPAIGN_ID)}
                    onSubmit={handleSubmit}
                >
                    {({ values, handleChange }) => (
                        <Form className="flex flex-col gap-4 mb-5 text-[1.8vh]">
                            {!!openModal?.DEMO_CAMPAIGN_ID && <OTPModal isOpen={{ ...openModal, ...values }} onRequestClose={() => setOpenModal(false)} onSubmit={e => handleSubmit(e)} sendOTP={() => handleInsert(values)} />}
                            {!!successModal?.key && <SuccessModal
                                isOpen={successModal}
                                onRequestClose={() => {
                                    if (successModal?.word === "closeALL") {
                                        handelModalClose()
                                    } else {
                                        setSuccessModal(false)
                                    }
                                }}
                            />}
                            <div className="flex flex-col gap-2">
                                <label className="block">Full Name <span className="text-red-700">*</span></label>
                                <div className="w-[100%] border border-solid border-black-500 px-1">
                                    <Field
                                        as="input"
                                        type="text"
                                        name="NAME"
                                        className="py-1 px-4 h-10 w-[100%]"
                                        placeholder=" Enter Full Name"
                                    />
                                </div>
                                <ErrorMessage name="NAME" component="div" className="text-red-600" />
                            </div>
                            <div className="flex flex-col gap-2">
                                <label className="block">Institution Name <span className="text-red-700">*</span></label>
                                <div className="w-[100%] border border-solid border-black-500 px-1">
                                    <Field
                                        type="text"
                                        name="INSTITUTE_NAME"
                                        className="py-1 px-4 h-10 w-[100%]"
                                        placeholder=" Enter Institution Name"
                                    />
                                </div>
                                <ErrorMessage name="INSTITUTE_NAME" component="div" className="text-red-600" />
                            </div>

                            <div className="grid grid-cols-2 gap-4 sm:grid-cols-1">
                                <div className="flex flex-col gap-2">
                                    <label className="block">Total School Strength <span className="text-red-700">*</span></label>
                                    <div className="w-[100%] border border-solid border-black-500 px-1">
                                        <Field
                                            type="text"
                                            name="TOTAL_STRENGTH"
                                            className="py-1 px-4 h-10 w-[100%]"
                                            placeholder=" Enter Total School Strength"
                                        />
                                    </div>
                                    <ErrorMessage name="TOTAL_STRENGTH" component="div" className="text-red-600" />
                                </div>
                                <div className="flex flex-col gap-2">
                                    <label className="block">Role</label>
                                    <div className="w-[100%] border border-solid border-black-500 px-1">
                                        <Field as="select" name="ROLE" className="py-1 px-4 h-10 w-[100%]">
                                            <option disabled value="">Select Role</option>
                                            {ROLE_LIST?.map(item => <option key={"ROLE_LISTDropdown" + item} value={item}>{item}</option>)}
                                        </Field>
                                    </div>
                                </div>
                                <div className="flex flex-col gap-2">
                                    <label className="block">Language <span className="text-red-700">*</span></label>
                                    <div className="w-[100%] border border-solid border-black-500 px-1">
                                        <Field as="select" name="LANGUAGE" className="p-2 rounded h-10 w-[100%]">
                                            <option disabled value="">Select Language</option>
                                            {LANGUAGE_LIST?.map(item => <option disabled={item === "Hindi - COMING SOON"} key={"languageDropdown" + item} value={item}>{item}</option>)}
                                        </Field>
                                    </div>
                                    <ErrorMessage name="LANGUAGE" component="div" className="text-red-600" />
                                </div>
                                <div className="flex flex-col gap-2">
                                    <label className="block">Mobile No/Whatsapp No <span className="text-red-700">*</span></label>
                                    <div className="border border-solid border-black-500 px-1">
                                        {/* <Field
                                            type="text"
                                            name="MOBILE_NUMBER"
                                            className="py-1 px-4 h-10 w-[100%]"
                                            placeholder={" Enter Mobile No/Whatsapp No"}
                                        /> */}
                                        <Field name="MOBILE_NUMBER">
                                            {({ field, form }) => (
                                                <input
                                                    {...field}
                                                    type="text"
                                                    className="py-1 px-4 h-10 w-[100%]"
                                                    placeholder="Enter Mobile No/Whatsapp No"
                                                    onChange={(e) => {
                                                        if (!!demoCampaignID?.DEMO_CAMPAIGN_ID) {
                                                            setDemoCampaignID({})
                                                        }
                                                        form.setFieldValue('MOBILE_NUMBER', e.target.value);
                                                    }}
                                                />
                                            )}
                                        </Field>
                                    </div>
                                    <ErrorMessage name="MOBILE_NUMBER" component="div" className="text-red-600" />
                                </div>
                                {/* {!!demoCampaignID?.DEMO_CAMPAIGN_ID && <div className="flex flex-col gap-2">
                                    <label className="block">OTP <span className="text-red-700">*</span></label>
                                    <div className="border border-solid border-black-500  px-1">
                                        <Field
                                            type="text"
                                            name="OTP"
                                            className="py-1 px-4 h-10 w-[100%]"
                                            placeholder={" Enter OTP"}
                                        />
                                    </div>
                                    <ErrorMessage name="OTP" component="div" className="text-red-600" />
                                </div>} */}
                            </div>
                            <div className="flex justify-end items-center gap-4">
                                <button type={"button"} onClick={handelModalClose} title="Cancel" className="font-medium border border-gray-200 py-2 px-4">
                                    Cancel
                                </button>
                                {formLoader ? (
                                    <div>
                                        <Img src="images/loader.gif" alt="loader" className="h-10" />
                                    </div>
                                ) : (
                                    <button title="Send OTP" className={`bg-smd_blue-normal text-[white] py-2 px-4`}>
                                        Submit
                                    </button>
                                )}
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>}
        </ModalR>
    );
}

export default CommunicationModal;